// extracted by mini-css-extract-plugin
module.exports = {"link":"ResendVerificationEmailError_link__5_VLv"};